/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Модель для отказа от товара допродажи в корзине
   */
  app.UpsaleItemRejection = app.Model.extend({
    url: app.entryScriptName + '/api/v3/upsale-item-rejection/',
  });
})(jQuery);

}.call(window));